export enum Dictionaries {
    expire = '__expire__',
    permanent = 'permanent'
}